import { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../components/ui/Modal';
import { ALL_STATUSES } from '../utils';

export function FilterModal({ open, onClose, values, onApply, onReset }) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(values);

  useEffect(() => {
    if (open) setDraft(values);
  }, [open, values]);

  function toggleStatut(s) {
    setDraft((d) => ({
      ...d,
      statut: d.statut.includes(s) ? d.statut.filter((x) => x !== s) : [...d.statut, s],
    }));
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('shipments.filter_modal_title')}
      size="sm"
      footer={
        <>
          <button
            onClick={() => { onReset(); onClose(); }}
            className="h-8 px-3 rounded-lg text-[12px] font-medium text-slate-600 hover:bg-slate-100 transition"
          >
            {t('shipments.filter_reset')}
          </button>
          <button
            onClick={() => { onApply(draft); onClose(); }}
            className="h-8 px-4 rounded-lg bg-primary text-white text-[12px] font-medium hover:opacity-90 transition"
          >
            {t('shipments.filter_apply')}
          </button>
        </>
      }
    >
      <div className="space-y-2">
        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide">
          {t('shipments.filter_statut_label')}
        </p>
        <div className="grid grid-cols-2 gap-1.5">
          {ALL_STATUSES.map((s) => {
            const checked = draft.statut.includes(s);
            return (
              <label
                key={s}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer text-[12px] font-medium transition select-none ${
                  checked
                    ? 'border-primary bg-primary/5 text-primary'
                    : 'border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50'
                }`}
              >
                <input type="checkbox" checked={checked} onChange={() => toggleStatut(s)} className="sr-only" />
                <span className={`w-3.5 h-3.5 rounded flex items-center justify-center border flex-shrink-0 ${
                  checked ? 'bg-primary border-primary' : 'border-slate-300'
                }`}>
                  {checked && <Check size={9} strokeWidth={3} className="text-white" />}
                </span>
                {t(`shipments.status_${s}`)}
              </label>
            );
          })}
        </div>
      </div>

      <div className="space-y-1.5">
        <label className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide">
          {t('shipments.filter_origin_label')}
        </label>
        <input
          type="text"
          value={draft.origin}
          onChange={(e) => setDraft((d) => ({ ...d, origin: e.target.value }))}
          placeholder={t('shipments.filter_origin_placeholder')}
          className="w-full h-9 px-3 border border-slate-200 rounded-lg text-[12.5px] outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-50 placeholder:text-slate-400 transition"
        />
      </div>

      <div className="space-y-1.5">
        <label className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide">
          {t('shipments.filter_destination_label')}
        </label>
        <input
          type="text"
          value={draft.destination}
          onChange={(e) => setDraft((d) => ({ ...d, destination: e.target.value }))}
          placeholder={t('shipments.filter_destination_placeholder')}
          className="w-full h-9 px-3 border border-slate-200 rounded-lg text-[12.5px] outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-50 placeholder:text-slate-400 transition"
        />
      </div>
    </Modal>
  );
}
